/**
 * Refraction mode.
 */
export enum RefractionMode {
  /** Use the sphere refraction model when light passes through the surface. */
  Sphere = 0,
  /** Use the planar refraction model when light passes through the surface. */
  Planar = 1
}
